export function formatJson(value) {
    return JSON.stringify(value, undefined, 2);
}
